module.exports = __webpack_public_path__ + "img/icon1.b2c973b4.png";